import { ACTIONS as logoutActions } from '@~/actions/logout';
import { ACTIONS } from '@~/actions/notification-home';

const initialState = {
  vibe: null,
};

export default function defaultExport(state = initialState, { type, payload }) {
  switch (type) {
    case ACTIONS.SET_VIBE: {
      return {
        ...state,
        vibe: payload,
      };
    }
    case logoutActions.POST_SUCCESS:
      return initialState;
    default:
      return state;
  }
}
